import styled from 'styled-components';
import { palette } from 'styled-tools';

import { minWidth } from '@calm-web/design-system';

export const Section = styled.section`
	display: flex;
	flex-direction: column;
	background: linear-gradient(${palette('white')}, ${palette('gray0')});
	padding: 0 14px;
`;

export const ButtonsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: center;
	column-gap: 10px;
	padding: 20px 0px;
	row-gap: 10px;
	${minWidth('desktop')} {
		column-gap: 30px;
		row-gap: 30px;
	}
`;

export const FeatureContainer = styled.div`
	display: grid;
	max-width: 1000px;
	margin: auto;
	justify-items: center;
	align-items: center;
	${minWidth('tablet')} {
		grid-template-columns: 1fr 1fr;
		gap: 48px;
	}
`;

export const FeatureInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	max-width: 440px;
	margin: 0 16px;
	${minWidth('tablet')} {
		max-width: 340px;
		margin: 0;
	}
`;

export const Column = styled.div`
	${minWidth('tablet')} {
		padding: 0 3rem;
	}
`;

export const FeatureIconWrapper = styled.div`
	display: none;
	svg path {
		fill: ${palette('blue3')};
	}
	${minWidth('tablet')} {
		display: initial;
	}
`;

export const FeatureImageWrapper = styled.div`
	max-width: 202px;
	margin-top: 30px;
	max-height: 284.5px;
	${minWidth('tablet')} {
		max-width: 354px;
		max-height: 500px;
	}
`;
